import React from "react"
import { useParams } from "react-router-dom"

import { Grid, Typography } from "@material-ui/core"

import Breadcrumb from "@/components/BreadcrumbNew"
import EditTrackableLinkForm from "@/pages/Admin/TrackableLinks/EditTrackableLink/EditTrackableLinkForm"

import { Trackablelink } from "@/protocols/trackableLinks"
import { Loading, Notification } from "@/components"

import ApiService from "@/services/Api"
import ErrorHandlerService from "@/services/ErrorHandler"
import useDidMount from "@/hooks/useDidMount"
import useValidation, { ErrorType } from "@/hooks/useValidation"

import useStyles from "@/pages/Admin/TrackableLinks/EditTrackableLink/styles"
import useQuery from "@/hooks/useQuery"

const EditTrackableLink: React.FC = () => {
	const searchParams = useQuery()
	const classes = useStyles()

	const isFromDetailsPage = searchParams.get("from") === "details"

	const { trackableLinkId } = useParams<{ trackableLinkId?: string }>()
	const { triggerValidation } = useValidation()

	const [loading, setLoading] = React.useState(false)
	const [trackableLink, setTrackableLink] = React.useState<Trackablelink>({} as Trackablelink)

	const handleGetTrackableLinkById = async () => {
		setLoading(true)
		try {
			const { data } = await ApiService.get<{ trackablelink: Trackablelink }>(`/trackable-links/${trackableLinkId}`)
			setTrackableLink(data.trackablelink)
		} catch (error) {
			Notification.error({ message: "Ocorreu um erro ao buscar as métricas" })

			triggerValidation(error as ErrorType)
			ErrorHandlerService.handle(error as ErrorType)
		}

		setLoading(false)
	}

	useDidMount(async () => {
		await handleGetTrackableLinkById()
	})

	return (
		<Loading loading={loading}>
			<Grid
				container
				direction="column"
				spacing={4}
			>
				<Grid item>
					<Breadcrumb
						data={[
							{ name: "Links rastreáveis", pathname: "/admin/conversion/tools/trackable-links" },
							...(isFromDetailsPage ? [{ name: `${trackableLink.title}`, pathname: `/admin/conversion/tools/trackable-links/${trackableLink.id}/details` }] : []),
							{ name: "Editar", pathname: `/admin/conversion/tools/trackable-links/${trackableLink.id}/edit` }
						]}
					/>
				</Grid>

				<Grid item>
					<Grid container direction="column" spacing={4}>
						<Grid item>
							<Typography
								variant="h5"
								className={classes.titleText}
							>
								Editar link
							</Typography>
						</Grid>

						<Grid item>
							<EditTrackableLinkForm trackablelink={trackableLink} />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Loading>
	)
}

export default EditTrackableLink
